import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

const SpinnerImgTag = styled.img`
  position: ${(props) => props.absolute && "absolute"};
  position: ${(props) => props.relative && "relative"};
  top: ${(props) => props.top && `${props.top}px`};
  right: ${(props) => props.right && `${props.right}px`};
  left: ${(props) => props.left && `${props.left}px`};
  bottom: ${(props) => props.bottom && `${props.bottom}px`};
  width: ${(props) => props.size && `${props.size}px`};
  height: ${(props) => props.size && `${props.size}px`};

  ${mediaMaxWidth.tablet`
    top: ${(props) => props.mobileTop && `${props.mobileTop}px`};
    right: ${(props) => props.mobileRight && `${props.mobileRight}px`};
    left: ${(props) => props.mobileLeft && `${props.mobileLeft}px`};
    bottom: ${(props) => props.mobileBottom && `${props.mobileBottom}px`};
  `}
`;

export { SpinnerImgTag as default };
